import { assertNever } from '@varos/util-typescript';
// Helper to convert editor annotations to core annotations
function buildCoreAnnotations(annotations) {
    return {
        bold: annotations.bold,
        italic: annotations.italic,
        underline: annotations.underline,
        strikethrough: false, // Not in EditorAnnotations
        code: false, // Not in EditorAnnotations
        color: null, // Not in EditorAnnotations
    };
}
// Helper to convert editor AnySpan to core SpanCreatePayload
function buildCoreSpan(span) {
    if (span.kind === 'text') {
        const editorSpan = span;
        return {
            kind: 'text',
            text: editorSpan.text,
            annotations: buildCoreAnnotations(editorSpan.annotations),
            href: editorSpan.href,
        };
    }
    if (span.kind === 'mention') {
        const editorSpan = span;
        return {
            kind: 'mention',
            text: editorSpan.text,
            annotations: buildCoreAnnotations(editorSpan.annotations),
            mention: editorSpan.mention, // Cast to generated.MentionConfig
        };
    }
    if (span.kind === 'reference') {
        const editorSpan = span;
        return {
            kind: 'reference',
            id: editorSpan.text, // Editor stores ID in text for reference spans
        };
    }
    return assertNever(span);
}
// Helper to convert editor AnyNode to core BlockCreatePayload
function buildCoreBlock(node) {
    if (node.kind === 'text') {
        const textNode = node;
        return {
            kind: 'text',
            items: textNode.content.map(buildCoreSpan),
        };
    }
    if (node.kind === 'heading') {
        const headingNode = node;
        return {
            kind: 'heading',
            level: headingNode.level,
            items: headingNode.content.map(buildCoreSpan),
        };
    }
    if (node.kind === 'list_item') {
        const listItemNode = node;
        return {
            kind: 'list_item',
            style: listItemNode.style,
            items: listItemNode.content.map(buildCoreSpan),
        };
    }
    if (node.kind === 'divider') {
        return {
            kind: 'divider',
        };
    }
    if (node.kind === 'callout') {
        const calloutNode = node;
        const textContent = calloutNode.content
            .map((s) => (s.kind === 'text' ? s.text : ''))
            .join(' ');
        return {
            kind: 'callout',
            text: textContent,
            icon: calloutNode.icon,
        };
    }
    if (node.kind === 'custom') {
        const customNode = node;
        // WARNING: CustomNode in editor-core is lossy for many block types.
        // The following attempts to create minimal valid payloads, but data will be missing or defaulted.
        switch (customNode.blockType) {
            case 'code':
                return {
                    kind: 'code',
                    language: 'plaintext',
                    text: `Custom block ID: ${customNode.blockId}`,
                };
            case 'button':
                return {
                    kind: 'button',
                    text: 'Button',
                    actions: [],
                };
            case 'database':
                return {
                    kind: 'database',
                    collection: '',
                    view: 'table',
                    config: {
                        kind: 'table',
                        title_property: undefined,
                        include_properties: [],
                    },
                };
            case 'database_view':
                return {
                    kind: 'database_view',
                    collection: '',
                    config: {
                        kind: 'list',
                        title_property: undefined,
                        include_properties: [],
                    },
                };
            case 'footnote':
                return {
                    kind: 'footnote',
                    items: [],
                };
            case 'quote':
                return {
                    kind: 'quote',
                    items: [],
                };
            // case 'task':
            //     return {
            //         kind: 'task',
            //         task: node.
            //     } as generated.TaskBlockCreatePayload;
            default:
                console.warn(`Unhandled custom blockType: ${customNode.blockType} during core block conversion. Returning minimal payload.`);
                return { kind: customNode.blockType };
        }
    }
    return assertNever(node);
}
// Main reverse transformation: EditorState -> BlockCreatePayload[]
export function buildCoreBlocksFromEditorState(state) {
    return state.nodes.map(buildCoreBlock);
}
//# sourceMappingURL=blockHelper.js.map